<template>
	<router-link
		:to="path"
		class="tw-text-primary-contrast tw-px-4 tw-py-4 hover:tw-opacity-80 hover:tw-text-primary-contrast">
		<font-awesome-icon
			v-if="icon"
			:icon="['fas', icon]" />
		<span
			class="tw-uppercase tw-font-medium tw-px-2"
			:class="icon ? 'tw-hidden sm:tw-inline' : 'tw-inline '"
			v-html="translationKey && t(translationKey)"></span>
	</router-link>
</template>
<script setup lang="ts">
import { useTranslation } from 'i18next-vue';


const { t } = useTranslation();
defineProps({
	path: {
		type: String,
		required: true,
	},
	translationKey: {
		type: String,
	},
	icon: {
		type: String,
	},
});
</script>